import ApiService from './api.service';

export default function ProductService() {}

ProductService.getProducts = () => {
  return ApiService.get(`/products`);
}
